<div class="livePannel">
    <!--*ngIf="!settings.liveInfo.isCreator"-->
    <div class="mediaPannel">
        <!--主播-->
        <ng-container *ngIf="settings.liveInfo.IsCreator else audience">

            <div class="small-video">
                <video [ngClass]="{'show-video':settings.liveInfo.Camera}" #camera autoplay playsinline muted></video>
            </div>

        </ng-container>

        <!--观众-->
        <ng-template #audience>

            <div class="big-video" *ngIf="settings.liveInfo.Screen">
                <video [ngClass]="{'show-video':settings.liveInfo.Screen}" #screen autoplay playsinline muted></video>
            </div>

            <div class="small-video" *ngIf="settings.liveInfo.Camera">
                <video [ngClass]="{'show-video':settings.liveInfo.Camera}" #camera autoplay playsinline muted></video>
            </div>
            <div style="font-size: 14px;"
                *ngIf="!settings.liveInfo.Screen&&!settings.liveInfo.Camera&&!settings.liveInfo.Audio">已暂停</div>
        </ng-template>

    </div>
    <div class="userPannel">
        <nz-layout class="userPanneLayout">
            <nz-header>
                <ng-container *ngIf="settings.liveInfo.IsCreator else isNotCreator">
                    <div class="live-header-master" (click)="close()">
                        <i nz-icon nzType="poweroff" nzTheme="outline"></i>
                    </div>
                </ng-container>
                <ng-template #isNotCreator>
                    <div class="live-header">
                        <ul class="ul-head">
                            <li (click)="close()">

                                <div class="app-header-ul-item"><i nz-icon nzType="close" nzTheme="outline"></i></div>
                            </li>
                        </ul>
                    </div>
                </ng-template>

                <div class="header-info">
                    <ul class="live-header-user">
                        <li>
                            <nz-avatar nzIcon="user" [nzShape]="'square'" [nzSrc]="settings.liveInfo?.HeadImg|src">
                            </nz-avatar>
                        </li>
                        <li class="name">{{settings.liveInfo.Title}}</li>
                        <li>
                            <nz-badge nzStatus="success"></nz-badge>
                        </li>
                        <li></li>
                    </ul>
                    <ul class="live-header-user inf">
                        <li class="live-header-user-liveInfo"><i class="live-time" nz-icon nzType="clock-circle"
                                nzTheme="fill"></i>{{timer}}</li>
                        <li><i nz-icon nzType="heart" nzTheme="fill"></i>{{settings.liveInfo.LikeNumber}}</li>
                        <li><i nz-icon nzType="user" nzTheme="outline"></i>{{settings.liveInfo.OnlineUser}}</li>
                    </ul>

                    <ul class="live-header-user tool" *ngIf="settings.liveInfo.IsCreator"
                        [ngClass]="{'lb':!settings.liveInfo.IsCreator}">
                        <li>
                            <div class="rage-border" (click)="cameraClick()"
                                [ngClass]="{'select':this.settings.liveInfo.Camera}"><i nz-icon nzType="video-camera"
                                    nzTheme="fill"></i></div>
                        </li>
                        <li>
                            <div class="rage-border" (click)="audioClick()"
                                [ngClass]="{'select':this.settings.liveInfo.Audio}"><i nz-icon nzType="audio"
                                    nzTheme="fill"></i></div>
                        </li>
                        <li>
                            <div class="rage-border" (click)="screenClick()"
                                [ngClass]="{'select':this.settings.liveInfo.Screen}"><i nz-icon nzType="desktop"
                                    nzTheme="outline"></i></div>
                        </li>
                    </ul>

                    <ul class="live-header-user mic" *ngIf="!settings.liveInfo.IsCreator">
                        <li>
                            <i nz-icon nzType="phone" nzTheme="fill"></i>
                            <!-- <i nz-icon nzType="phone" nzTheme="outline"></i> -->
                        </li>
                        <li>
                            <i nz-icon nzType="message" nzTheme="fill"></i>
                            <!-- <i nz-icon nzType="message" nzTheme="outline"></i> -->
                        </li>
                    </ul>
                </div>
            </nz-header>
            <nz-content>
                <div class="live_context_title">
                    <span class="live_context_t_right">
                        <i nz-icon nzType="phone" nzTheme="fill"></i>
                    </span>
                    <span>
                        <span>连麦</span>
                    </span>

                    <div class="live_context_mic">
                        <span>与主播连麦进行通话</span>
                        <button nz-button [nzSize]="'small'" nzType="primary">申请连麦</button>
                    </div>
                </div>
                <div class="live_context_comment">
                    <div style="display: flex;">
                        <span class="comment_title">
                            <i nz-icon nzType="message" nzTheme="fill"></i>
                        </span>
                        <span class="comment_title" (click)="tab(1)"
                            [ngClass]="{'live_context_comment_focus':tabIndex==1}">
                            <span>评论</span>
                        </span>
                        <span class="comment_title" (click)="tab(2)"
                            [ngClass]="{'live_context_comment_focus':tabIndex==2}">
                            <span>在线人数</span>
                        </span>
                    </div>
                    <div id="chatContext" class="live_context_comment_chat" (mousewheel)="onmousewheel($event)"
                        (scroll)="onscroll($event)" *ngIf="tabIndex==1">
                        <div class="msg-items">
                            <div class="more">
                                <nz-spin *ngIf="loadingChatRecord" nzSimple [nzSize]="'small'"></nz-spin>
                                <a *ngIf="!loadingChatRecord&&pageInfo.pageIndex!=pageInfo.totalPage&&pageInfo.totalPage>0"
                                    (click)="morePage()">查看更多消息</a>
                            </div>
                            <div class="msg_item" *ngFor="let item of this.chatRecordData index as i">
                                <div class="system_msg" *ngIf="item.Type==100 else msg">
                                    <div style="text-align: center;">
                                        <span class="system_msg_title">直播间消息：直播已经发送至好友</span>
                                    </div>
                                </div>
                                <ng-template #msg>
                                    <div class="comment-msg">
                                        <span style="margin-right: 8px;">
                                            <nz-avatar [nzSize]="16" nzIcon="user" [nzShape]="'square'"
                                                [nzSrc]="item.SendUserHeadImg|src">
                                            </nz-avatar>
                                        </span>
                                        <span class="text_vertical_middle">{{item.SendName}} ：</span>
                                        <span class="text_vertical_middle">
                                            <app-text-element [text]="item.MessageText">
                                            </app-text-element>
                                        </span>

                                    </div>
                                </ng-template>
                            </div>

                        </div>
                    </div>
                    <div class="live_context_comment_users" *ngIf="tabIndex==2">

                    </div>

                </div>

            </nz-content>
            <nz-footer [ngClass]="{'ban-message':settings.liveInfo.BanMessage&&!settings.liveInfo.IsCreator}">
                <div class="menu_tool" [ngClass]="{'ban-click':settings.liveInfo.BanMessage&&!settings.liveInfo.IsCreator}">
                    <span (click)="banMessageClick()"><i nz-icon nzType="stop" nzTheme="fill"></i></span>
                    <span nz-popover nzPopoverTrigger="click" [nzPopoverContent]="contentTemplate"
                        [(nzPopoverVisible)]="showEmojiPicker"><i nz-icon nzType="smile" nzTheme="fill"></i>
                        <ng-template #contentTemplate>
                            <div class="emoji_main">
                                <!-- <emoji-mart [set]="'apple'" [include]="emoji" [showPreview]="false"
[enableSearch]="false" (emojiClick)="emojiClick($event)"></emoji-mart> -->
                                <app-emoji-picker (select)="emojiClick($event)"></app-emoji-picker>
                            </div>
                        </ng-template>
                    </span>
                </div>
                <div class="send_main" [ngClass]="{'ban-click':settings.liveInfo.BanMessage&&!settings.liveInfo.IsCreator}">
                    <div #messageTextElement class="textarea" (keydown)="onTextKeyDown($event)" contenteditable="true"
                        (keyup)="textareaInput($event)" ondragstart="return false"></div>
                    <div class="send" (click)="send()">发送</div>
                </div>

            </nz-footer>
        </nz-layout>
    </div>
</div>
<app-REC-range *ngIf="settings.liveInfo.Screen&&settings.liveInfo.IsCreator"></app-REC-range>